import { executeRequest, JFSRequest } from '@jfs/network'
import { getIdFromMap, isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

// TODO: update
const getRequestBody = (data: any) => {
  return {
    chiper: data?.chiper,
    entityId: getIdFromMap(data?.entityId),
    instrumentType: getIdFromMap(data?.instrumentType),
    mcfg1: data?.mcfg1,
    mcfg2: data?.mcfg2,
    meCode: data?.meCode,
    merchantId: data?.merchantId,
    pgSecurityId: data?.pgSecurityId,
    secret: data?.secret,
    txnType: getIdFromMap(data?.txnType),
    reqType: getIdFromMap(data?.reqType),
    emiCode: data?.emiCode,
    offerCode: data?.offerCode,
    productId: data?.productId,
    mappingStatus: data?.mappingStatus === 'Deactivate' ? 'false' : 'true',
  }
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addMerchantMapping = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.addMerchantMapping),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addMerchantMapping }
